import { useMutation } from '@apollo/client';
import registerViaGoogleMutation from './RegisterViaGoogleMutation';
import { RETURN_URL_REGISTER } from '../../../../Login/ByExternalProvider/LoginReturnUrls';

const RegisterViaGoogleConnectorApollo = ({ children }) => {
  const [mutate, { loading }] = useMutation(registerViaGoogleMutation);

  const createRegisterViaGoogle = async (token, returnUrl) => {
    const response = await mutate({
      variables: {
        token,
        authorizationCode: returnUrl || RETURN_URL_REGISTER,
      },
    });

    return response;
  };

  return children({
    registerViaGoogle: createRegisterViaGoogle,
    loading,
  });
};

export default RegisterViaGoogleConnectorApollo;
